/*!
 * fullPage 2.9.4
 * https://github.com/alvarotrigo/fullPage.js
 * @license MIT licensed
 *
 * Copyright (C) 2015 alvarotrigo.com - A project by Alvaro Trigo
 */
!function(e, n) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], function(t) {
        return n(t, e, e.document, e.Math)
    }) : "object" == typeof exports && exports ? module.exports = n(require("jquery"), e, e.document, e.Math) : n(jQuery, e, e.document, e.Math)
}("undefined" != typeof window ? window : this, function(e, n, t, o, i) {
    "use strict";
    var a = "fullpage-wrapper"
      , r = "." + a
      , l = "fp-scrollable"
      , s = "." + l
      , c = "fp-responsive"
      , d = "fp-notransition"
      , f = "fp-destroyed"
      , u = "fp-enabled"
      , h = "fp-viewing"
      , p = "active"
      , v = "." + p
      , g = "fp-completely"
      , m = "." + g
      , w = ".section"
      , S = "fp-section"
      , y = "." + S
      , b = y + v
      , x = y + ":first"
      , C = y + ":last"
      , T = "fp-tableCell"
      , k = "." + T
      , I = "fp-auto-height"
      , L = "fp-normal-scroll"
      , E = "fp-nav"
      , M = "#" + E
      , O = "fp-tooltip"
      , A = "." + O
      , R = "fp-show-active"
      , H = ".slide"
      , B = "fp-slide"
      , z = "." + B
      , D = z + v
      , P = "fp-slides"
      , q = "." + P
      , F = "fp-slidesContainer"
      , V = "." + F
      , W = "fp-table"
      , U = "fp-slidesNav"
      , Y = "." + U
      , j = Y + " a"
      , N = "fp-controlArrow"
      , X = "." + N
      , K = "fp-prev"
      , Q = "." + K
      , G = N + " " + K
      , J = X + Q
      , Z = "fp-next"
      , $ = "." + Z
      , _ = N + " " + Z
      , ee = X + $
      , ne = e(n)
      , te = e(t)
      , oe = {
        scrollbars: !0,
        mouseWheel: !0,
        hideScrollbars: !1,
        fadeScrollbars: !1,
        disableMouse: !0,
        interactiveScrollbars: !0
    };
    e.fn.fullpage = function(l) {
        function s(n, t) {
            n || nt(0),
            rt("autoScrolling", n, t);
            var o = e(b);
            l.autoScrolling && !l.scrollBar ? (ct.css({
                overflow: "hidden",
                height: "100%"
            }),
            N(Bt.recordHistory, "internal"),
            St.css({
                "-ms-touch-action": "none",
                "touch-action": "none"
            }),
            o.length && nt(o.position().top)) : (ct.css({
                overflow: "visible",
                height: "initial"
            }),
            N(!1, "internal"),
            St.css({
                "-ms-touch-action": "",
                "touch-action": ""
            }),
            o.length && ct.scrollTop(o.position().top))
        }
        function N(e, n) {
            rt("recordHistory", e, n)
        }
        function Q(e, n) {
            rt("scrollingSpeed", e, n)
        }
        function Z(e, n) {
            rt("fitToSection", e, n)
        }
        function $(e) {
            l.lockAnchors = e
        }
        function ae(e) {
            e ? (Kn(),
            Qn()) : (Xn(),
            Gn())
        }
        function re(n, t) {
            "undefined" != typeof t ? (t = t.replace(/ /g, "").split(","),
            e.each(t, function(e, t) {
                ot(n, t, "m")
            })) : n ? (ae(!0),
            Jn()) : (ae(!1),
            Zn())
        }
        function le(n, t) {
            "undefined" != typeof t ? (t = t.replace(/ /g, "").split(","),
            e.each(t, function(e, t) {
                ot(n, t, "k")
            })) : l.keyboardScrolling = n
        }
        function se() {
            var n = e(b).prev(y);
            n.length || !l.loopTop && !l.continuousVertical || (n = e(y).last()),
            n.length && Ke(n, null, !0)
        }
        function ce() {
            var n = e(b).next(y);
            n.length || !l.loopBottom && !l.continuousVertical || (n = e(y).first()),
            n.length && Ke(n, null, !1)
        }
        function de(e, n) {
            Q(0, "internal"),
            fe(e, n),
            Q(Bt.scrollingSpeed, "internal")
        }
        function fe(e, n) {
            var t = Dn(e);
            "undefined" != typeof n ? qn(e, n) : t.length > 0 && Ke(t)
        }
        function ue(e) {
            je("right", e)
        }
        function he(e) {
            je("left", e)
        }
        function pe(n) {
            if (!St.hasClass(f)) {
                bt = !0,
                yt = ne.height(),
                e(y).each(function() {
                    var n = e(this).find(q)
                      , t = e(this).find(z);
                    l.verticalCentered && e(this).find(k).css("height", Bn(e(this)) + "px"),
                    e(this).css("height", yt + "px"),
                    l.scrollOverflow && (t.length ? t.each(function() {
                        Rn(e(this))
                    }) : Rn(e(this))),
                    t.length > 1 && Sn(n, n.find(D))
                });
                var t = e(b)
                  , o = t.index(y);
                o && de(o + 1),
                bt = !1,
                e.isFunction(l.afterResize) && n && l.afterResize.call(St),
                e.isFunction(l.afterReBuild) && !n && l.afterReBuild.call(St)
            }
        }
        function ve(n) {
            var t = dt.hasClass(c);
            n ? t || (s(!1, "internal"),
            Z(!1, "internal"),
            e(M).hide(),
            dt.addClass(c),
            e.isFunction(l.afterResponsive) && l.afterResponsive.call(St, n)) : t && (s(Bt.autoScrolling, "internal"),
            Z(Bt.autoScrolling, "internal"),
            e(M).show(),
            dt.removeClass(c),
            e.isFunction(l.afterResponsive) && l.afterResponsive.call(St, n))
        }
        function ge() {
            l.css3 && (l.css3 = Nn()),
            l.scrollBar = l.scrollBar || l.hybrid,
            we(),
            Se(),
            re(!0),
            s(l.autoScrolling, "internal"),
            Tn(),
            jn(),
            "complete" === t.readyState && rn(),
            ne.on("load", rn)
        }
        function me() {
            ne.on("scroll", Re).on("hashchange", ln).blur(pn).resize(Cn),
            te.keydown(sn).keyup(dn).on("click touchstart", M + " a", vn).on("click touchstart", j, gn).on("click", A, cn),
            e(y).on("click touchstart", X, hn),
            l.normalScrollElements && (te.on("mouseenter", l.normalScrollElements, function() {
                ae(!1)
            }),
            te.on("mouseleave", l.normalScrollElements, function() {
                ae(!0)
            }))
        }
        function we() {
            var n = St.find(l.sectionSelector);
            l.anchors.length || (l.anchors = n.filter("[data-anchor]").map(function() {
                return e(this).data("anchor").toString()
            }).get()),
            l.navigationTooltips.length || (l.navigationTooltips = n.filter("[data-tooltip]").map(function() {
                return e(this).data("tooltip").toString()
            }).get())
        }
        function Se() {
            St.css({
                height: "100%",
                position: "relative"
            }),
            St.addClass(a),
            e("html").addClass(u),
            yt = ne.height(),
            St.removeClass(f),
            Ce(),
            e(y).each(function(n) {
                var t = e(this)
                  , o = t.find(z)
                  , i = o.length;
                be(t, n),
                xe(t, n),
                i > 0 ? ye(t, o, i) : l.verticalCentered && Hn(t)
            }),
            l.fixedElements && l.css3 && e(l.fixedElements).appendTo(dt),
            l.navigation && ke(),
            Le(),
            l.scrollOverflow ? ("complete" === t.readyState && Ie(),
            ne.on("load", Ie)) : Oe()
        }
        function ye(n, t, o) {
            var i = 100 * o
              , a = 100 / o;
            t.wrapAll('<div class="' + F + '" />'),
            t.parent().wrap('<div class="' + P + '" />'),
            n.find(V).css("width", i + "%"),
            o > 1 && (l.controlArrows && Te(n),
            l.slidesNavigation && Vn(n, o)),
            t.each(function(n) {
                e(this).css("width", a + "%"),
                l.verticalCentered && Hn(e(this))
            });
            var r = n.find(D);
            r.length && (0 !== e(b).index(y) || 0 === e(b).index(y) && 0 !== r.index()) ? et(r, "internal") : t.eq(0).addClass(p)
        }
        function be(n, t) {
            t || 0 !== e(b).length || n.addClass(p),
            vt = e(b),
            n.css("height", yt + "px"),
            l.paddingTop && n.css("padding-top", l.paddingTop),
            l.paddingBottom && n.css("padding-bottom", l.paddingBottom),
            "undefined" != typeof l.sectionsColor[t] && n.css("background-color", l.sectionsColor[t]),
            "undefined" != typeof l.anchors[t] && n.attr("data-anchor", l.anchors[t])
        }
        function xe(n, t) {
            "undefined" != typeof l.anchors[t] && n.hasClass(p) && Mn(l.anchors[t], t),
            l.menu && l.css3 && e(l.menu).closest(r).length && e(l.menu).appendTo(dt)
        }
        function Ce() {
            St.find(l.sectionSelector).addClass(S),
            St.find(l.slideSelector).addClass(B)
        }
        function Te(e) {
            e.find(q).after('<div class="' + G + '"></div><div class="' + _ + '"></div>'),
            "#fff" != l.controlArrowColor && (e.find(ee).css("border-color", "transparent transparent transparent " + l.controlArrowColor),
            e.find(J).css("border-color", "transparent " + l.controlArrowColor + " transparent transparent")),
            l.loopHorizontal || e.find(J).hide()
        }
        function ke() {
            dt.append('<div id="' + E + '"><ul></ul></div>');
            var n = e(M);
            n.addClass(function() {
                return l.showActiveTooltip ? R + " " + l.navigationPosition : l.navigationPosition
            });
            for (var t = 0; t < e(y).length; t++) {
                var o = "";
                l.anchors.length && (o = l.anchors[t]);
                var i = '<li><a href="#' + o + '"><span></span></a>'
                  , a = l.navigationTooltips[t];
                "undefined" != typeof a && "" !== a && (i += '<div class="' + O + " " + l.navigationPosition + '">' + a + "</div>"),
                i += "</li>",
                n.find("ul").append(i)
            }
            e(M).css("margin-top", "-" + e(M).height() / 2 + "px"),
            e(M).find("li").eq(e(b).index(y)).find("a").addClass(p)
        }
        function Ie() {
            e(y).each(function() {
                var n = e(this).find(z);
                n.length ? n.each(function() {
                    Rn(e(this))
                }) : Rn(e(this))
            }),
            Oe()
        }
        function Le() {
            St.find('iframe[src*="youtube.com/embed/"]').each(function() {
                Ee(e(this), "enablejsapi=1")
            })
        }
        function Ee(e, n) {
            var t = e.attr("src");
            e.attr("src", t + Me(t) + n)
        }
        function Me(e) {
            return /\?/.test(e) ? "&" : "?"
        }
        function Oe() {
            var n = e(b);
            n.addClass(g),
            l.scrollOverflowHandler.afterRender && l.scrollOverflowHandler.afterRender(n),
            en(n),
            nn(n),
            l.scrollOverflowHandler.afterLoad(),
            Ae() && e.isFunction(l.afterLoad) && l.afterLoad.call(n, n.data("anchor"), n.index(y) + 1),
            e.isFunction(l.afterRender) && l.afterRender.call(St)
        }
        function Ae() {
            var e = n.location.hash.replace("#", "").split("/")
              , t = Dn(decodeURIComponent(e[0]));
            return !t.length || t.length && t.index() === vt.index()
        }
        function Re() {
            var n;
            if (!l.autoScrolling || l.scrollBar) {
                var o = ne.scrollTop()
                  , i = ze(o)
                  , a = 0
                  , r = o + ne.height() / 2
                  , s = dt.height() - ne.height() === o
                  , c = t.querySelectorAll(y);
                if (s)
                    a = c.length - 1;
                else if (o)
                    for (var d = 0; d < c.length; ++d) {
                        var f = c[d];
                        f.offsetTop <= r && (a = d)
                    }
                else
                    a = 0;
                if (Be(i) && (e(b).hasClass(g) || e(b).addClass(g).siblings().removeClass(g)),
                n = e(c).eq(a),
                !n.hasClass(p)) {
                    zt = !0;
                    var u, h, v = e(b), m = v.index(y) + 1, w = On(n), S = n.data("anchor"), x = n.index(y) + 1, C = n.find(D);
                    C.length && (h = C.data("anchor"),
                    u = C.index()),
                    Ct && (n.addClass(p).siblings().removeClass(p),
                    e.isFunction(l.onLeave) && l.onLeave.call(v, m, x, w),
                    e.isFunction(l.afterLoad) && l.afterLoad.call(n, S, x),
                    on(v),
                    en(n),
                    nn(n),
                    Mn(S, x - 1),
                    l.anchors.length && (ut = S),
                    Wn(u, h, S, x)),
                    clearTimeout(Mt),
                    Mt = setTimeout(function() {
                        zt = !1
                    }, 100)
                }
                l.fitToSection && (clearTimeout(Ot),
                Ot = setTimeout(function() {
                    l.fitToSection && He()
                }, l.fitToSectionDelay))
            }
        }
        function He() {
            Ct && (bt = !0,
            Ke(e(b)),
            bt = !1)
        }
        function Be(n) {
            var t = e(b).position().top
              , o = t + ne.height();
            return "up" == n ? o >= ne.scrollTop() + ne.height() : t <= ne.scrollTop()
        }
        function ze(e) {
            var n = e > Dt ? "down" : "up";
            return Dt = e,
            Ut = e,
            n
        }
        function De(e, n) {
            if (kt.m[e]) {
                var t = "down" === e ? "bottom" : "top"
                  , o = "down" === e ? ce : se;
                if (n.length > 0) {
                    if (!l.scrollOverflowHandler.isScrolled(t, n))
                        return !0;
                    o()
                } else
                    o()
            }
        }
        function Pe(e) {
            var n = e.originalEvent;
            !Fe(e.target) && l.autoScrolling && Ve(n) && e.preventDefault()
        }
        function qe(n) {
            var t = n.originalEvent
              , i = e(t.target).closest(y);
            if (!Fe(n.target) && Ve(t)) {
                l.autoScrolling && n.preventDefault();
                var a = l.scrollOverflowHandler.scrollable(i)
                  , r = _n(t);
                Ft = r.y,
                Vt = r.x,
                i.find(q).length && o.abs(qt - Vt) > o.abs(Pt - Ft) ? !gt && o.abs(qt - Vt) > ne.outerWidth() / 100 * l.touchSensitivity && (qt > Vt ? kt.m.right && ue(i) : kt.m.left && he(i)) : l.autoScrolling && Ct && o.abs(Pt - Ft) > ne.height() / 100 * l.touchSensitivity && (Pt > Ft ? De("down", a) : Ft > Pt && De("up", a))
            }
        }
        function Fe(n, t) {
            t = t || 0;
            var o = e(n).parent();
            return t < l.normalScrollElementTouchThreshold && o.is(l.normalScrollElements) ? !0 : t == l.normalScrollElementTouchThreshold ? !1 : Fe(o, ++t)
        }
        function Ve(e) {
            return "undefined" == typeof e.pointerType || "mouse" != e.pointerType
        }
        function We(e) {
            var n = e.originalEvent;
            if (l.fitToSection && ct.stop(),
            Ve(n)) {
                var t = _n(n);
                Pt = t.y,
                qt = t.x
            }
        }
        function Ue(e, n) {
            for (var t = 0, i = e.slice(o.max(e.length - n, 1)), a = 0; a < i.length; a++)
                t += i[a];
            return o.ceil(t / n)
        }
        function Ye(t) {
            var i = (new Date).getTime()
              , a = e(m).hasClass(L);
            if (l.autoScrolling && !pt && !a) {
                t = t || n.event;
                var r = t.wheelDelta || -t.deltaY || -t.detail
                  , s = o.max(-1, o.min(1, r))
                  , c = "undefined" != typeof t.wheelDeltaX || "undefined" != typeof t.deltaX
                  , d = o.abs(t.wheelDeltaX) < o.abs(t.wheelDelta) || o.abs(t.deltaX) < o.abs(t.deltaY) || !c;
                Tt.length > 149 && Tt.shift(),
                Tt.push(o.abs(r)),
                l.scrollBar && (t.preventDefault ? t.preventDefault() : t.returnValue = !1);
                var f = e(b)
                  , u = l.scrollOverflowHandler.scrollable(f)
                  , h = i - Wt;
                if (Wt = i,
                h > 200 && (Tt = []),
                Ct) {
                    var p = Ue(Tt, 10)
                      , v = Ue(Tt, 70)
                      , g = p >= v;
                    g && d && (0 > s ? De("down", u) : De("up", u))
                }
                return !1
            }
            l.fitToSection && ct.stop()
        }
        function je(n, t) {
            var o = "undefined" == typeof t ? e(b) : t
              , i = o.find(q)
              , a = i.find(z).length;
            if (!(!i.length || gt || 2 > a)) {
                var r = i.find(D)
                  , s = null;
                if (s = "left" === n ? r.prev(z) : r.next(z),
                !s.length) {
                    if (!l.loopHorizontal)
                        return;
                    s = "left" === n ? r.siblings(":last") : r.siblings(":first")
                }
                gt = !0,
                Sn(i, s, n)
            }
        }
        function Ne() {
            e(D).each(function() {
                et(e(this), "internal")
            })
        }
        function Xe(e) {
            var n = e.position()
              , t = n.top
              , o = n.top > Ut
              , i = t - yt + e.outerHeight()
              , a = l.bigSectionsDestination;
            return e.outerHeight() > yt ? (!o && !a || "bottom" === a) && (t = i) : (o || bt && e.is(":last-child")) && (t = i),
            Ut = t,
            t
        }
        function Ke(n, t, o) {
            if ("undefined" != typeof n) {
                var i, a, r = Xe(n), s = {
                    element: n,
                    callback: t,
                    isMovementUp: o,
                    dtop: r,
                    yMovement: On(n),
                    anchorLink: n.data("anchor"),
                    sectionIndex: n.index(y),
                    activeSlide: n.find(D),
                    activeSection: e(b),
                    leavingSection: e(b).index(y) + 1,
                    localIsResizing: bt
                };
                s.activeSection.is(n) && !bt || l.scrollBar && ne.scrollTop() === s.dtop && !n.hasClass(I) || (s.activeSlide.length && (i = s.activeSlide.data("anchor"),
                a = s.activeSlide.index()),
                l.autoScrolling && l.continuousVertical && "undefined" != typeof s.isMovementUp && (!s.isMovementUp && "up" == s.yMovement || s.isMovementUp && "down" == s.yMovement) && (s = Je(s)),
                (!e.isFunction(l.onLeave) || s.localIsResizing || l.onLeave.call(s.activeSection, s.leavingSection, s.sectionIndex + 1, s.yMovement) !== !1) && (s.localIsResizing || on(s.activeSection),
                l.scrollOverflowHandler.beforeLeave(),
                n.addClass(p).siblings().removeClass(p),
                en(n),
                l.scrollOverflowHandler.onLeave(),
                Ct = !1,
                Wn(a, i, s.anchorLink, s.sectionIndex),
                Qe(s),
                ut = s.anchorLink,
                Mn(s.anchorLink, s.sectionIndex)))
            }
        }
        function Qe(n) {
            if (l.css3 && l.autoScrolling && !l.scrollBar) {
                var t = "translate3d(0px, -" + o.round(n.dtop) + "px, 0px)";
                zn(t, !0),
                l.scrollingSpeed ? (clearTimeout(Lt),
                Lt = setTimeout(function() {
                    $e(n)
                }, l.scrollingSpeed)) : $e(n)
            } else {
                var i = Ge(n);
                e(i.element).animate(i.options, l.scrollingSpeed, l.easing).promise().done(function() {
                    l.scrollBar ? setTimeout(function() {
                        $e(n)
                    }, 30) : $e(n)
                })
            }
        }
        function Ge(e) {
            var n = {};
            return l.autoScrolling && !l.scrollBar ? (n.options = {
                top: -e.dtop
            },
            n.element = r) : (n.options = {
                scrollTop: e.dtop
            },
            n.element = "html, body"),
            n
        }
        function Je(n) {
            return n.isMovementUp ? e(b).before(n.activeSection.nextAll(y)) : e(b).after(n.activeSection.prevAll(y).get().reverse()),
            nt(e(b).position().top),
            Ne(),
            n.wrapAroundElements = n.activeSection,
            n.dtop = n.element.position().top,
            n.yMovement = On(n.element),
            n
        }
        function Ze(n) {
            n.wrapAroundElements && n.wrapAroundElements.length && (n.isMovementUp ? e(x).before(n.wrapAroundElements) : e(C).after(n.wrapAroundElements),
            nt(e(b).position().top),
            Ne())
        }
        function $e(n) {
            Ze(n),
            e.isFunction(l.afterLoad) && !n.localIsResizing && l.afterLoad.call(n.element, n.anchorLink, n.sectionIndex + 1),
            l.scrollOverflowHandler.afterLoad(),
            n.localIsResizing || nn(n.element),
            n.element.addClass(g).siblings().removeClass(g),
            Ct = !0,
            e.isFunction(n.callback) && n.callback.call(this)
        }
        function _e(e, n) {
            e.attr(n, e.data(n)).removeAttr("data-" + n)
        }
        function en(n) {
            if (l.lazyLoading) {
                var t, o = an(n);
                o.find("img[data-src], img[data-srcset], source[data-src], audio[data-src], iframe[data-src]").each(function() {
                    t = e(this),
                    e.each(["src", "srcset"], function(e, n) {
                        var o = t.attr("data-" + n);
                        "undefined" != typeof o && o && _e(t, n)
                    }),
                    t.is("source") && t.closest("video").get(0).load()
                })
            }
        }
        function nn(n) {
            var t = an(n);
            t.find("video, audio").each(function() {
                var n = e(this).get(0);
                n.hasAttribute("data-autoplay") && "function" == typeof n.play && n.play()
            }),
            t.find('iframe[src*="youtube.com/embed/"]').each(function() {
                var n = e(this).get(0);
                n.hasAttribute("data-autoplay") && tn(n),
                n.onload = function() {
                    n.hasAttribute("data-autoplay") && tn(n)
                }
            })
        }
        function tn(e) {
            e.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*")
        }
        function on(n) {
            var t = an(n);
            t.find("video, audio").each(function() {
                var n = e(this).get(0);
                n.hasAttribute("data-keepplaying") || "function" != typeof n.pause || n.pause()
            }),
            t.find('iframe[src*="youtube.com/embed/"]').each(function() {
                var n = e(this).get(0);
                /youtube\.com\/embed\//.test(e(this).attr("src")) && !n.hasAttribute("data-keepplaying") && e(this).get(0).contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
            })
        }
        function an(n) {
            var t = n.find(D);
            return t.length && (n = e(t)),
            n
        }
        function rn() {
            var e = n.location.hash.replace("#", "").split("/")
              , t = decodeURIComponent(e[0])
              , o = decodeURIComponent(e[1]);
            t && (l.animateAnchor ? qn(t, o) : de(t, o))
        }
        function ln() {
            if (!zt && !l.lockAnchors) {
                var e = n.location.hash.replace("#", "").split("/")
                  , t = decodeURIComponent(e[0])
                  , o = decodeURIComponent(e[1])
                  , i = "undefined" == typeof ut
                  , a = "undefined" == typeof ut && "undefined" == typeof o && !gt;
                t.length && (t && t !== ut && !i || a || !gt && ht != o) && qn(t, o)
            }
        }
        function sn(n) {
            clearTimeout(At);
            var t = e(":focus");
            if (!t.is("textarea") && !t.is("input") && !t.is("select") && "true" !== t.attr("contentEditable") && "" !== t.attr("contentEditable") && l.keyboardScrolling && l.autoScrolling) {
                var o = n.which
                  , i = [40, 38, 32, 33, 34];
                e.inArray(o, i) > -1 && n.preventDefault(),
                pt = n.ctrlKey,
                At = setTimeout(function() {
                    mn(n)
                }, 150)
            }
        }
        function cn() {
            e(this).prev().trigger("click")
        }
        function dn(e) {
            xt && (pt = e.ctrlKey)
        }
        function fn(e) {
            2 == e.which && (Yt = e.pageY,
            St.on("mousemove", wn))
        }
        function un(e) {
            2 == e.which && St.off("mousemove")
        }
        function hn() {
            var n = e(this).closest(y);
            e(this).hasClass(K) ? kt.m.left && he(n) : kt.m.right && ue(n)
        }
        function pn() {
            xt = !1,
            pt = !1
        }
        function vn(n) {
            n.preventDefault();
            var t = e(this).parent().index();
            Ke(e(y).eq(t))
        }
        function gn(n) {
            n.preventDefault();
            var t = e(this).closest(y).find(q)
              , o = t.find(z).eq(e(this).closest("li").index());
            Sn(t, o)
        }
        function mn(n) {
            var t = n.shiftKey;
            if (Ct || !([37, 39].indexOf(n.which) < 0))
                switch (n.which) {
                case 38:
                case 33:
                    kt.k.up && se();
                    break;
                case 32:
                    if (t && kt.k.up) {
                        se();
                        break
                    }
                case 40:
                case 34:
                    kt.k.down && ce();
                    break;
                case 36:
                    kt.k.up && fe(1);
                    break;
                case 35:
                    kt.k.down && fe(e(y).length);
                    break;
                case 37:
                    kt.k.left && he();
                    break;
                case 39:
                    kt.k.right && ue();
                    break;
                default:
                    return
                }
        }
        function wn(e) {
            Ct && (e.pageY < Yt && kt.m.up ? se() : e.pageY > Yt && kt.m.down && ce()),
            Yt = e.pageY
        }
        function Sn(n, t, o) {
            var i = n.closest(y)
              , a = {
                slides: n,
                destiny: t,
                direction: o,
                destinyPos: t.position(),
                slideIndex: t.index(),
                section: i,
                sectionIndex: i.index(y),
                anchorLink: i.data("anchor"),
                slidesNav: i.find(Y),
                slideAnchor: Yn(t),
                prevSlide: i.find(D),
                prevSlideIndex: i.find(D).index(),
                localIsResizing: bt
            };
            return a.xMovement = An(a.prevSlideIndex, a.slideIndex),
            a.localIsResizing || (Ct = !1),
            l.onSlideLeave && !a.localIsResizing && "none" !== a.xMovement && e.isFunction(l.onSlideLeave) && l.onSlideLeave.call(a.prevSlide, a.anchorLink, a.sectionIndex + 1, a.prevSlideIndex, a.xMovement, a.slideIndex) === !1 ? void (gt = !1) : (t.addClass(p).siblings().removeClass(p),
            a.localIsResizing || (on(a.prevSlide),
            en(t)),
            !l.loopHorizontal && l.controlArrows && (i.find(J).toggle(0 !== a.slideIndex),
            i.find(ee).toggle(!t.is(":last-child"))),
            i.hasClass(p) && !a.localIsResizing && Wn(a.slideIndex, a.slideAnchor, a.anchorLink, a.sectionIndex),
            void bn(n, a, !0))
        }
        function yn(n) {
            xn(n.slidesNav, n.slideIndex),
            n.localIsResizing || (e.isFunction(l.afterSlideLoad) && l.afterSlideLoad.call(n.destiny, n.anchorLink, n.sectionIndex + 1, n.slideAnchor, n.slideIndex),
            Ct = !0,
            nn(n.destiny)),
            gt = !1
        }
        function bn(e, n, t) {
            var i = n.destinyPos;
            if (l.css3) {
                var a = "translate3d(-" + o.round(i.left) + "px, 0px, 0px)";
                kn(e.find(V)).css(tt(a)),
                Et = setTimeout(function() {
                    t && yn(n)
                }, l.scrollingSpeed, l.easing)
            } else
                e.animate({
                    scrollLeft: o.round(i.left)
                }, l.scrollingSpeed, l.easing, function() {
                    t && yn(n)
                })
        }
        function xn(e, n) {
            e.find(v).removeClass(p),
            e.find("li").eq(n).find("a").addClass(p)
        }
        function Cn() {
            if (Tn(),
            mt) {
                var n = e(t.activeElement);
                if (!n.is("textarea") && !n.is("input") && !n.is("select")) {
                    var i = ne.height();
                    o.abs(i - jt) > 20 * o.max(jt, i) / 100 && (pe(!0),
                    jt = i)
                }
            } else
                clearTimeout(It),
                It = setTimeout(function() {
                    pe(!0)
                }, 350)
        }
        function Tn() {
            var e = l.responsive || l.responsiveWidth
              , n = l.responsiveHeight
              , t = e && ne.outerWidth() < e
              , o = n && ne.height() < n;
            e && n ? ve(t || o) : e ? ve(t) : n && ve(o)
        }
        function kn(e) {
            var n = "all " + l.scrollingSpeed + "ms " + l.easingcss3;
            return e.removeClass(d),
            e.css({
                "-webkit-transition": n,
                transition: n
            })
        }
        function In(e) {
            return e.addClass(d)
        }
        function Ln(n, t) {
            l.navigation && (e(M).find(v).removeClass(p),
            n ? e(M).find('a[href="#' + n + '"]').addClass(p) : e(M).find("li").eq(t).find("a").addClass(p))
        }
        function En(n) {
            l.menu && (e(l.menu).find(v).removeClass(p),
            e(l.menu).find('[data-menuanchor="' + n + '"]').addClass(p))
        }
        function Mn(e, n) {
            En(e),
            Ln(e, n)
        }
        function On(n) {
            var t = e(b).index(y)
              , o = n.index(y);
            return t == o ? "none" : t > o ? "up" : "down"
        }
        function An(e, n) {
            return e == n ? "none" : e > n ? "left" : "right"
        }
        function Rn(e) {
            if (!e.hasClass("fp-noscroll")) {
                e.css("overflow", "hidden");
                var n, t = l.scrollOverflowHandler, o = t.wrapContent(), i = e.closest(y), a = t.scrollable(e);
                a.length ? n = t.scrollHeight(e) : (n = e.get(0).scrollHeight,
                l.verticalCentered && (n = e.find(k).get(0).scrollHeight));
                var r = yt - parseInt(i.css("padding-bottom")) - parseInt(i.css("padding-top"));
                n > r ? a.length ? t.update(e, r) : (l.verticalCentered ? e.find(k).wrapInner(o) : e.wrapInner(o),
                t.create(e, r)) : t.remove(e),
                e.css("overflow", "")
            }
        }
        function Hn(e) {
            e.hasClass(W) || e.addClass(W).wrapInner('<div class="' + T + '" style="height:' + Bn(e) + 'px;" />')
        }
        function Bn(e) {
            var n = yt;
            if (l.paddingTop || l.paddingBottom) {
                var t = e;
                t.hasClass(S) || (t = e.closest(y));
                var o = parseInt(t.css("padding-top")) + parseInt(t.css("padding-bottom"));
                n = yt - o
            }
            return n
        }
        function zn(e, n) {
            n ? kn(St) : In(St),
            St.css(tt(e)),
            setTimeout(function() {
                St.removeClass(d)
            }, 10)
        }
        function Dn(n) {
            if (!n)
                return [];
            var t = St.find(y + '[data-anchor="' + n + '"]');
            return t.length || (t = e(y).eq(n - 1)),
            t
        }
        function Pn(e, n) {
            var t = n.find(q)
              , o = t.find(z + '[data-anchor="' + e + '"]');
            return o.length || (o = t.find(z).eq(e)),
            o
        }
        function qn(e, n) {
            var t = Dn(e);
            t.length && ("undefined" == typeof n && (n = 0),
            e === ut || t.hasClass(p) ? Fn(t, n) : Ke(t, function() {
                Fn(t, n)
            }))
        }
        function Fn(e, n) {
            if ("undefined" != typeof n) {
                var t = e.find(q)
                  , o = Pn(n, e);
                o.length && Sn(t, o)
            }
        }
        function Vn(e, n) {
            e.append('<div class="' + U + '"><ul></ul></div>');
            var t = e.find(Y);
            t.addClass(l.slidesNavPosition);
            for (var o = 0; n > o; o++)
                t.find("ul").append('<li><a href="#"><span></span></a></li>');
            t.css("margin-left", "-" + t.width() / 2 + "px"),
            t.find("li").first().find("a").addClass(p)
        }
        function Wn(e, n, t, o) {
            var i = "";
            l.anchors.length && !l.lockAnchors && (e ? ("undefined" != typeof t && (i = t),
            "undefined" == typeof n && (n = e),
            ht = n,
            Un(i + "/" + n)) : "undefined" != typeof e ? (ht = n,
            Un(t)) : Un(t)),
            jn()
        }
        function Un(e) {
            if (l.recordHistory)
                location.hash = e;
            else if (mt || wt)
                n.history.replaceState(i, i, "#" + e);
            else {
                var t = n.location.href.split("#")[0];
                n.location.replace(t + "#" + e)
            }
        }
        function Yn(e) {
            var n = e.data("anchor")
              , t = e.index();
            return "undefined" == typeof n && (n = t),
            n
        }
        function jn() {
            var n = e(b)
              , t = n.find(D)
              , o = Yn(n)
              , i = Yn(t)
              , a = String(o);
            t.length && (a = a + "-" + i),
            a = a.replace("/", "-").replace("#", "");
            var r = new RegExp("\\b\\s?" + h + "-[^\\s]+\\b","g");
            dt[0].className = dt[0].className.replace(r, ""),
            dt.addClass(h + "-" + a)
        }
        function Nn() {
            var e, o = t.createElement("p"), a = {
                webkitTransform: "-webkit-transform",
                OTransform: "-o-transform",
                msTransform: "-ms-transform",
                MozTransform: "-moz-transform",
                transform: "transform"
            };
            t.body.insertBefore(o, null);
            for (var r in a)
                o.style[r] !== i && (o.style[r] = "translate3d(1px,1px,1px)",
                e = n.getComputedStyle(o).getPropertyValue(a[r]));
            return t.body.removeChild(o),
            e !== i && e.length > 0 && "none" !== e
        }
        function Xn() {
            t.addEventListener ? (t.removeEventListener("mousewheel", Ye, !1),
            t.removeEventListener("wheel", Ye, !1),
            t.removeEventListener("MozMousePixelScroll", Ye, !1)) : t.detachEvent("onmousewheel", Ye)
        }
        function Kn() {
            var e, o = "";
            n.addEventListener ? e = "addEventListener" : (e = "attachEvent",
            o = "on");
            var a = "onwheel"in t.createElement("div") ? "wheel" : t.onmousewheel !== i ? "mousewheel" : "DOMMouseScroll";
            "DOMMouseScroll" == a ? t[e](o + "MozMousePixelScroll", Ye, !1) : t[e](o + a, Ye, !1)
        }
        function Qn() {
            St.on("mousedown", fn).on("mouseup", un)
        }
        function Gn() {
            St.off("mousedown", fn).off("mouseup", un)
        }
        function Jn() {
            (mt || wt) && (l.autoScrolling && dt.off(Ht.touchmove).on(Ht.touchmove, Pe),
            e(r).off(Ht.touchstart).on(Ht.touchstart, We).off(Ht.touchmove).on(Ht.touchmove, qe))
        }
        function Zn() {
            (mt || wt) && e(r).off(Ht.touchstart).off(Ht.touchmove)
        }
        function $n() {
            var e;
            return e = n.PointerEvent ? {
                down: "pointerdown",
                move: "pointermove"
            } : {
                down: "MSPointerDown",
                move: "MSPointerMove"
            }
        }
        function _n(e) {
            var n = [];
            return n.y = "undefined" != typeof e.pageY && (e.pageY || e.pageX) ? e.pageY : e.touches[0].pageY,
            n.x = "undefined" != typeof e.pageX && (e.pageY || e.pageX) ? e.pageX : e.touches[0].pageX,
            wt && Ve(e) && l.scrollBar && (n.y = e.touches[0].pageY,
            n.x = e.touches[0].pageX),
            n
        }
        function et(e, n) {
            Q(0, "internal"),
            "undefined" != typeof n && (bt = !0),
            Sn(e.closest(q), e),
            "undefined" != typeof n && (bt = !1),
            Q(Bt.scrollingSpeed, "internal")
        }
        function nt(e) {
            var n = o.round(e);
            if (l.css3 && l.autoScrolling && !l.scrollBar) {
                var t = "translate3d(0px, -" + n + "px, 0px)";
                zn(t, !1)
            } else
                l.autoScrolling && !l.scrollBar ? St.css("top", -n) : ct.scrollTop(n)
        }
        function tt(e) {
            return {
                "-webkit-transform": e,
                "-moz-transform": e,
                "-ms-transform": e,
                transform: e
            }
        }
        function ot(e, n, t) {
            switch (n) {
            case "up":
                kt[t].up = e;
                break;
            case "down":
                kt[t].down = e;
                break;
            case "left":
                kt[t].left = e;
                break;
            case "right":
                kt[t].right = e;
                break;
            case "all":
                "m" == t ? re(e) : le(e)
            }
        }
        function it(n) {
            s(!1, "internal"),
            re(!1),
            le(!1),
            St.addClass(f),
            clearTimeout(Et),
            clearTimeout(Lt),
            clearTimeout(It),
            clearTimeout(Mt),
            clearTimeout(Ot),
            ne.off("scroll", Re).off("hashchange", ln).off("resize", Cn),
            te.off("click touchstart", M + " a").off("mouseenter", M + " li").off("mouseleave", M + " li").off("click touchstart", j).off("mouseover", l.normalScrollElements).off("mouseout", l.normalScrollElements),
            e(y).off("click touchstart", X),
            clearTimeout(Et),
            clearTimeout(Lt),
            n && at()
        }
        function at() {
            nt(0),
            St.find("img[data-src], source[data-src], audio[data-src], iframe[data-src]").each(function() {
                _e(e(this), "src")
            }),
            St.find("img[data-srcset]").each(function() {
                _e(e(this), "srcset")
            }),
            e(M + ", " + Y + ", " + X).remove(),
            e(y).css({
                height: "",
                "background-color": "",
                padding: ""
            }),
            e(z).css({
                width: ""
            }),
            St.css({
                height: "",
                position: "",
                "-ms-touch-action": "",
                "touch-action": ""
            }),
            ct.css({
                overflow: "",
                height: ""
            }),
            e("html").removeClass(u),
            dt.removeClass(c),
            e.each(dt.get(0).className.split(/\s+/), function(e, n) {
                0 === n.indexOf(h) && dt.removeClass(n)
            }),
            e(y + ", " + z).each(function() {
                l.scrollOverflowHandler.remove(e(this)),
                e(this).removeClass(W + " " + p)
            }),
            In(St),
            St.find(k + ", " + V + ", " + q).each(function() {
                e(this).replaceWith(this.childNodes)
            }),
            St.css({
                "-webkit-transition": "none",
                transition: "none"
            }),
            ct.scrollTop(0);
            var n = [S, B, F];
            e.each(n, function(n, t) {
                e("." + t).removeClass(t)
            })
        }
        function rt(e, n, t) {
            l[e] = n,
            "internal" !== t && (Bt[e] = n)
        }
        function lt() {
            var n = ["fadingEffect", "continuousHorizontal", "scrollHorizontally", "interlockedSlides", "resetSliders", "responsiveSlides", "offsetSections", "dragAndMove", "scrollOverflowReset", "parallax"];
            return e("html").hasClass(u) ? void st("error", "Fullpage.js can only be initialized once and you are doing it multiple times!") : (l.continuousVertical && (l.loopTop || l.loopBottom) && (l.continuousVertical = !1,
            st("warn", "Option `loopTop/loopBottom` is mutually exclusive with `continuousVertical`; `continuousVertical` disabled")),
            l.scrollBar && l.scrollOverflow && st("warn", "Option `scrollBar` is mutually exclusive with `scrollOverflow`. Sections with scrollOverflow might not work well in Firefox"),
            !l.continuousVertical || !l.scrollBar && l.autoScrolling || (l.continuousVertical = !1,
            st("warn", "Scroll bars (`scrollBar:true` or `autoScrolling:false`) are mutually exclusive with `continuousVertical`; `continuousVertical` disabled")),
            e.each(n, function(e, n) {
                l[n] && st("warn", "fullpage.js extensions require jquery.fullpage.extensions.min.js file instead of the usual jquery.fullpage.js. Requested: " + n)
            }),
            void e.each(l.anchors, function(n, t) {
                var o = te.find("[name]").filter(function() {
                    return e(this).attr("name") && e(this).attr("name").toLowerCase() == t.toLowerCase()
                })
                  , i = te.find("[id]").filter(function() {
                    return e(this).attr("id") && e(this).attr("id").toLowerCase() == t.toLowerCase()
                });
                (i.length || o.length) && (st("error", "data-anchor tags can not have the same value as any `id` element on the site (or `name` element for IE)."),
                i.length && st("error", '"' + t + '" is is being used by another element `id` property'),
                o.length && st("error", '"' + t + '" is is being used by another element `name` property'))
            }))
        }
        function st(e, n) {
            console && console[e] && console[e]("fullPage: " + n)
        }
        if (e("html").hasClass(u))
            return void lt();
        var ct = e("html, body")
          , dt = e("body")
          , ft = e.fn.fullpage;
        l = e.extend({
            menu: !1,
            anchors: [],
            lockAnchors: !1,
            navigation: !1,
            navigationPosition: "right",
            navigationTooltips: [],
            showActiveTooltip: !1,
            slidesNavigation: !1,
            slidesNavPosition: "bottom",
            scrollBar: !1,
            hybrid: !1,
            css3: !0,
            scrollingSpeed: 700,
            autoScrolling: !0,
            fitToSection: !0,
            fitToSectionDelay: 1e3,
            easing: "easeInOutCubic",
            easingcss3: "ease",
            loopBottom: !1,
            loopTop: !1,
            loopHorizontal: !0,
            continuousVertical: !1,
            continuousHorizontal: !1,
            scrollHorizontally: !1,
            interlockedSlides: !1,
            dragAndMove: !1,
            offsetSections: !1,
            resetSliders: !1,
            fadingEffect: !1,
            normalScrollElements: null,
            scrollOverflow: !1,
            scrollOverflowReset: !1,
            scrollOverflowHandler: ie,
            scrollOverflowOptions: null,
            touchSensitivity: 5,
            normalScrollElementTouchThreshold: 5,
            bigSectionsDestination: null,
            keyboardScrolling: !0,
            animateAnchor: !0,
            recordHistory: !0,
            controlArrows: !0,
            controlArrowColor: "#fff",
            verticalCentered: !0,
            sectionsColor: [],
            paddingTop: 0,
            paddingBottom: 0,
            fixedElements: null,
            responsive: 0,
            responsiveWidth: 0,
            responsiveHeight: 0,
            responsiveSlides: !1,
            parallax: !1,
            parallaxOptions: {
                type: "reveal",
                percentage: 62,
                property: "translate"
            },
            sectionSelector: w,
            slideSelector: H,
            afterLoad: null,
            onLeave: null,
            afterRender: null,
            afterResize: null,
            afterReBuild: null,
            afterSlideLoad: null,
            onSlideLeave: null,
            afterResponsive: null,
            lazyLoading: !0
        }, l);
        var ut, ht, pt, vt, gt = !1, mt = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|playbook|silk|BlackBerry|BB10|Windows Phone|Tizen|Bada|webOS|IEMobile|Opera Mini)/), wt = "ontouchstart"in n || navigator.msMaxTouchPoints > 0 || navigator.maxTouchPoints, St = e(this), yt = ne.height(), bt = !1, xt = !0, Ct = !0, Tt = [], kt = {};
        kt.m = {
            up: !0,
            down: !0,
            left: !0,
            right: !0
        },
        kt.k = e.extend(!0, {}, kt.m);
        var It, Lt, Et, Mt, Ot, At, Rt = $n(), Ht = {
            touchmove: "ontouchmove"in n ? "touchmove" : Rt.move,
            touchstart: "ontouchstart"in n ? "touchstart" : Rt.down
        }, Bt = e.extend(!0, {}, l);
        lt(),
        oe.click = wt,
        oe = e.extend(oe, l.scrollOverflowOptions),
        e.extend(e.easing, {
            easeInOutCubic: function(e, n, t, o, i) {
                return (n /= i / 2) < 1 ? o / 2 * n * n * n + t : o / 2 * ((n -= 2) * n * n + 2) + t
            }
        }),
        e(this).length && (ft.setAutoScrolling = s,
        ft.setRecordHistory = N,
        ft.setScrollingSpeed = Q,
        ft.setFitToSection = Z,
        ft.setLockAnchors = $,
        ft.setMouseWheelScrolling = ae,
        ft.setAllowScrolling = re,
        ft.setKeyboardScrolling = le,
        ft.moveSectionUp = se,
        ft.moveSectionDown = ce,
        ft.silentMoveTo = de,
        ft.moveTo = fe,
        ft.moveSlideRight = ue,
        ft.moveSlideLeft = he,
        ft.fitToSection = He,
        ft.reBuild = pe,
        ft.setResponsive = ve,
        ft.destroy = it,
        ge(),
        me());
        var zt = !1
          , Dt = 0
          , Pt = 0
          , qt = 0
          , Ft = 0
          , Vt = 0
          , Wt = (new Date).getTime()
          , Ut = 0
          , Yt = 0
          , jt = yt
    }
    ,
    "undefined" != typeof IScroll && (IScroll.prototype.wheelOn = function() {
        this.wrapper.addEventListener("wheel", this),
        this.wrapper.addEventListener("mousewheel", this),
        this.wrapper.addEventListener("DOMMouseScroll", this)
    }
    ,
    IScroll.prototype.wheelOff = function() {
        this.wrapper.removeEventListener("wheel", this),
        this.wrapper.removeEventListener("mousewheel", this),
        this.wrapper.removeEventListener("DOMMouseScroll", this)
    }
    );
    var ie = {
        refreshId: null,
        iScrollInstances: [],
        toggleWheel: function(n) {
            var t = e(b).find(s);
            t.each(function() {
                var t = e(this).data("iscrollInstance");
                "undefined" != typeof t && t && (n ? t.wheelOn() : t.wheelOff())
            })
        },
        onLeave: function() {
            ie.toggleWheel(!1)
        },
        beforeLeave: function() {
            ie.onLeave()
        },
        afterLoad: function() {
            ie.toggleWheel(!0)
        },
        create: function(n, t) {
            var o = n.find(s);
            o.height(t),
            o.each(function() {
                var n = e(this)
                  , t = n.data("iscrollInstance");
                t && e.each(ie.iScrollInstances, function() {
                    e(this).destroy()
                }),
                t = new IScroll(n.get(0),oe),
                ie.iScrollInstances.push(t),
                t.wheelOff(),
                n.data("iscrollInstance", t)
            })
        },
        isScrolled: function(e, n) {
            var t = n.data("iscrollInstance");
            return t ? "top" === e ? t.y >= 0 && !n.scrollTop() : "bottom" === e ? 0 - t.y + n.scrollTop() + 1 + n.innerHeight() >= n[0].scrollHeight : void 0 : !0
        },
        scrollable: function(e) {
            return e.find(q).length ? e.find(D).find(s) : e.find(s)
        },
        scrollHeight: function(e) {
            return e.find(s).children().first().get(0).scrollHeight
        },
        remove: function(e) {
            var n = e.find(s);
            if (n.length) {
                var t = n.data("iscrollInstance");
                t.destroy(),
                n.data("iscrollInstance", null)
            }
            e.find(s).children().first().children().first().unwrap().unwrap()
        },
        update: function(n, t) {
            clearTimeout(ie.refreshId),
            ie.refreshId = setTimeout(function() {
                e.each(ie.iScrollInstances, function() {
                    e(this).get(0).refresh()
                })
            }, 150),
            n.find(s).css("height", t + "px").parent().css("height", t + "px")
        },
        wrapContent: function() {
            return '<div class="' + l + '"><div class="fp-scroller"></div></div>'
        }
    }
});